import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { TileType, type TileDescriptor } from "@features/overview-v2/types";
import {
  CreativeMetricType,
  type GetOverviewMetricsReport_me_overviewMetricsReport,
  type SalesPageMetric,
} from "@north-beam/nb-client-side";

import { TileEllipsisMenu } from "./ellipsis-menu";

export interface TileHeaderProps {
  readonly tile: TileDescriptor;
  readonly variant: "single" | "multi";
  readonly metric1: SalesPageMetric;
  readonly metric2?: SalesPageMetric;
  readonly metric1Data: GetOverviewMetricsReport_me_overviewMetricsReport;
  readonly metric2Data?: GetOverviewMetricsReport_me_overviewMetricsReport;
  readonly onDelete: () => void;
  className?: string;
}

export const TileHeader = ({
  tile,
  metric1,
  metric2,
  metric1Data,
  metric2Data,
  variant,
  onDelete,
  ...props
}: TileHeaderProps): JSX.Element => {
  let defaultName = metric1.metadata.overviewPageMetricName || metric1.name;

  if (tile.type === TileType.CONVERSION_LAG) {
    defaultName += " Conversion Lag";
  }

  const name = tile.name || defaultName;

  return (
    <div
      {...props}
      className={clsx("flex flex-row gap-1 items-center", props.className)}
    >
      {variant === "single" &&
        metric1.composition?.type === CreativeMetricType.user_defined && (
          <GenericTooltip
            noInfoCircle
            content="Custom metric"
            className="truncate"
          >
            <i className="fa-regular fa-function text-cosmic" />
          </GenericTooltip>
        )}
      <h5 className="heading text-v2-primary mx-0 mb-0 mt-0 font-bold line-clamp-1 truncate leading-[32px] grow mr-2">
        <GenericTooltip noInfoCircle content={name} className="truncate">
          {name}
        </GenericTooltip>
      </h5>
      <TileEllipsisMenu
        tile={tile}
        metric1={metric1}
        metric2={metric2}
        metric1Data={metric1Data}
        metric2Data={metric2Data}
        onDelete={onDelete}
      />
    </div>
  );
};
